<template>
    <div>
        <Title>Gallery</Title>
        <v-flex xs12>
            <span style="font-size: 16pt;">This is a small sample of our work.</span>
        </v-flex>

        <v-container grid-list-sm>
            <v-layout wrap>
                <v-flex xs6 sm4 v-for="image in images" :key="image.id">
                    <v-img
                            :src="imageUrl + 'gallery/' + image.name" :height="thumbHeight"
                            @click.stop="openDialog(image)"
                    ></v-img>
                </v-flex>
            </v-layout>
        </v-container>

        <v-flex xs12 style="text-align: right;" v-if="showMore">
            <v-btn outlined color="error" to="/gallery">More...</v-btn>
        </v-flex>

        <v-flex xs12>
            <span style="font-size: 16pt;"><br /></span>
        </v-flex>
        <div class="imgbox" v-if="dialog">
            <img :src="selectedImage" class="center-fit" @click="closeDialog()">
        </div>
        <div id="overlay" @click="closeDialog()"></div>
        <div :class="{'imgbox': dialog}" @click="closeDialog()">
            <img :src="imageUrl + 'gallery/' + selectedImage" class="center-fit" @click="closeDialog()" v-if="(selectedImage !== undefined) && (selectedImage !== '')"/>
        </div>
    </div>
</template>

<script>
    import Title from './Title'
    import { sync } from 'vuex-pathify';

    export default {
        name: 'GallerComponent',
        components: { Title },
        props: ['images','showMore'],
        data () {
            return {
                dialog: false,
                thumbHeight: 250,
                selectedImage: '',
            }
        },
        computed: {
            ...sync(['imageUrl'])
        },
        methods: {
            openDialog: function(image) {
                document.getElementById("overlay").style.display = "block";
                this.selectedImage = image.name;
                this.dialog = true;
            },
            closeDialog: function() {
                this.selectedImage = '';
                this.dialog = false;
                document.getElementById("overlay").style.display = "none";
            }

        }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }
    .imgbox {
        position: fixed;
        top: 5%;
        left: 5%;
        width: 90%;
        height: 90%;
        z-index: 3; /* Specify a stack order in case you're using a different order for other elements */
    }
    .center-fit {
        max-height: 100%;
        max-width: 100%;
        margin: auto;
        display: block;
    }
    #overlay {
        position: fixed; /* Sit on top of the page content */
        display: none; /* Hidden by default */
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5); /* Black background with opacity */
        z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
        cursor: pointer; /* Add a pointer on hover */
    }
</style>
